// The same navbar action in its two presentations: an icon on a top bar or
// collapsed rail, a readable row on an expanded rail. The label comes from
// the action's existing localized title; its handlers and guards stay owned
// by the action itself.
export const NavbarRailControl = {
  extends: ['AppControl', 'NavbarTooltipTrigger'],
  compact: true,
  padding: '0',
  touchAction: 'manipulation',
  '@coarse': {
    minHeight: 'controlH',
    minWidth: 'controlH',
    ':after': { display: 'none' }
  },
  'data-nav-rail': (el, s) => (el.call('navbarLayoutRead', s.root) || {}).railMode,
  '&[data-nav-rail]': {
    height: 'controlHCompact',
    minHeight: 'controlHCompact',
    minWidth: 'controlHCompact',
    boxSizing: 'border-box',
    aspectRatio: 'auto',
    fontSize: 'inherit',
    flexShrink: '0',
    // Keep the media override with the compact selector so it is emitted
    // after that selector at the same specificity.
    '@coarse': { height: 'controlH', minHeight: 'controlH', minWidth: 'controlH' }
  },
  '&[data-nav-rail="narrow"]': {
    width: 'controlHCompact',
    padding: '0',
    '@coarse': { width: 'controlH' }
  },
  '&[data-nav-rail="wide"]': {
    width: '100%',
    maxWidth: '100%',
    aspectRatio: 'auto',
    justifyContent: 'flex-start',
    gap: 'Z',
    padding: 'Y Z',
    round: 'radiusControl',
    boxSizing: 'border-box',
    textAlign: 'left'
  },
  '&[data-nav-rail] > [data-key="Icon"]': {
    boxSize: 'iconSm',
    flexShrink: '0',
    order: '-1'
  },
  tooltipText: (el, s) => {
    if ((el.call('navbarLayoutRead', s.root) || {}).expanded) return ''
    const title = el.title
    return typeof title === 'function' ? title(el, s, el.context) : title
  },
  NavLabel: {
    tag: 'span',
    hide: (el, s) => !(el.call('navbarLayoutRead', s.root) || {}).expanded,
    text: (el, s) => {
      const control = el.parent
      const title = control.title
      return typeof title === 'function' ? title(control, s, control.context) : title
    },
    minWidth: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: '400'
  }
}
